module.exports = function() {

    var moment = require('moment');

    showEmploymentHistory();

    function showEmploymentHistory(){
        var $employmentHistoryModal = $('#employmentHistoryModal');

        $(document).on('click', '.js-employment-history-show', function(e){

            e.preventDefault();

            var $this = $(this),
                id = $this.data('id');

            $.getJSON('/api/employment-history/get/'+id, function(data) {

                for (var key in data) {

                    if(key == 'date_start' || key == 'date_end'){
                        if (data[key] != null) {
                            data[key] = moment(data[key]).format('DD/MM/YYYY');
                        } else {
                            data[key] = 'Still working there';
                        }
                    }

                    insertData(key, data[key], $employmentHistoryModal);
                }

                $employmentHistoryModal.modal('show');
            });

        });

    }

    var insertData = function(field_name, value, $modal) {
        var $field = $modal.find('#EH-'+field_name);

            $field.html(value);
    }

}();
